import { render, staticRenderFns } from "./SiteLayout.vue?vue&type=template&id=6c827e5b&"
import script from "./SiteLayout.vue?vue&type=script&lang=js&"
export * from "./SiteLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports